type ArrowAngleProps = {
  color?: string; // Optional color prop
};

export const ArrowAngle: React.FC<ArrowAngleProps> = ({
  color = '#1C3A13',
}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'>
    <path
      stroke={color}
      strokeWidth='1.5'
      d='M12 3.99999V8m0-4.00001H8m4 0L8 8m3 2v2H4V5h2'
    />
  </svg>
);
